import useCustomMutation from "@/composables/useCustomMutation";
import { MutationParams } from "@/interfaces/mutationParams";
import axios from "@/lib/axios";
import { useMutation } from "@tanstack/vue-query";
import { useToast } from "vue-toastification";

const deactivateAccountInternal = async (params: { id: number }) => {
  const { data } = await axios.delete(`/api/internal/users/${params.id}`);
  return data;
};

const reactivateAccountInternal = async (params: { id: number }) => {
  const { data } = await axios.post(`/api/internal/users/${params.id}/restore`);
  return data;
};

//TODO: ADD internal to the path this a feature that is not implemented yet for user internals is will be implemented in the future
// const handleInviteUser = async () => {};

// const registerUserInvitation = async () => {};

// const inviteMassiveUser = async () => {};

// const changePassword = async () => {};

// const changePasswordWithToken = async () => {};

// const sendPasswordResetEmail = async () => {};

const useAccountInternal = () => {
  const toast = useToast();

  const deactivateAccountMutation = useMutation(
    ({ params }: MutationParams<{ id: number }>) =>
      deactivateAccountInternal(params),
    useCustomMutation(toast, "delete"),
  );

  const reactivateAccountMutation = useMutation(
    ({ params }: MutationParams<{ id: number }>) =>
      reactivateAccountInternal(params),
    useCustomMutation(toast, "update"),
  );

  return {
    deactivateAccountMutation,
    reactivateAccountMutation,
  };
};

export default useAccountInternal;
